export default [
  {
    id: 'built_in',
    brand: 'piriod',
    countries: ['CL'],
    docs: '/docs/settings-invoicing-built_in',
    routeName: 'BillersBuiltInSettings',
    invoiceTypes: [
      'Factura electrónica',
      'Factura exenta electrónica',
      'Factura electrónica de exportación',
      'Boleta electrónica',
      'Boleta electrónica exenta'
    ],
    otherTypes: [
      'Nota de crédito electrónica',
      'Nota de crédito electrónica de exportación',
      'Nota de débito electrónica',
      'Nota de débito electrónica de exportación'
    ],
    title: 'Facturación incorporada',
    website: 'https://www.piriod.com'
  },
  {
    id: 'facturapi',
    apiKeyLabel: 'Api Key',
    brand: 'facturapi',
    countries: ['MX'],
    docs: '/docs/settings-invoicing-facturapi',
    invoiceTypes: [
      'Factura de ingreso',
      'Factura de pago'
    ],
    otherTypes: [],
    routeName: 'IntegrationsFacturapi',
    title: 'Facturapi',
    website: 'https://www.facturapi.io'
  },
  {
    id: 'defontana',
    apiKeyLabel: 'Email',
    brand: 'defontana',
    countries: ['CL'],
    docs: '/docs/settings-invoicing-defontana',
    invoiceTypes: [
      'Factura electrónica',
      'Factura exenta electrónica',
      'Boleta electrónica',
      'Boleta electrónica exenta'
    ],
    otherTypes: [
      'Nota de crédito electrónica',
      'Nota de débito electrónica'
    ],
    routeName: 'IntegrationsDefontana',
    title: 'Defontana',
    website: 'https://www.defontana.com'
  },
  {
    id: 'bsale',
    apiKeyLabel: 'Access Token',
    brand: 'bsale',
    countries: ['CL'],
    docs: '/docs/settings-invoicing-bsale',
    invoiceTypes: [
      'Factura electrónica',
      'Factura exenta electrónica',
      'Boleta electrónica',
      'Boleta electrónica exenta'
    ],
    otherTypes: [
      'Nota de crédito electrónica',
      'Nota de débito electrónica'
    ],
    routeName: 'BillersBiller',
    title: 'Bsale',
    website: 'https://www.bsale.cl'
  },
  {
    id: 'nfe',
    apiKeyLabel: 'Api Key',
    brand: 'nfe',
    countries: ['BR'],
    docs: '/docs/settings-invoicing-nfe',
    invoiceTypes: [
      'Nota fiscal de servicio'
    ],
    otherTypes: [],
    routeName: 'IntegrationsNfe',
    title: 'NFE.io',
    website: 'https://www.nfe.io'
  }
]